import { AbwKontoInhaberModel } from './AbwKontoInhaber';
import { AppUtils } from '../../utils/index';
/**
 * Model for the iban calculator form data.
 */
export class BankdatenModel {
	protected abwKontoInhaber: AbwKontoInhaberModel;
	private hatAbweichendenKontoInhaber: boolean;
	private bic: string;
	private iban: string;
	private bankEinzugSchutzbrief: boolean;
	private bankEinzugMitglied: boolean;
	private bankname: string;
	private mandateReference: string;
	private pseudocardpan: string;
	private cardtype: string;
	private truncatedcardpan: string;
	private cardexpiredate: string;
	private zahlungsweise: string;
	private creditCardStatus: string;
	private ccLastname: string;
	private ccFirstname: string;

	public get CcFirstname(): string {
		return this.ccFirstname;
	}
	public set CcFirstname(value: string) {
		this.ccFirstname = value;
	}

	public get CcLastname(): string {
		return this.ccLastname;
	}
	public set CcLastname(value: string) {
		this.ccLastname = value;
	}

	public get CreditCardStatus(): string {
		return this.creditCardStatus;
	}
	public set CreditCardStatus(value: string) {
		this.creditCardStatus = value;
	}

	public get Zahlungsweise(): string {
		return this.zahlungsweise;
	}
	public set Zahlungsweise(value: string) {
		this.zahlungsweise = value;
	}

	public get Cardexpiredate(): string {
		return this.cardexpiredate.substring(2).concat(`/${this.cardexpiredate.substring(0, 2)}`);
	}
	public set Cardexpiredate(value: string) {
		this.cardexpiredate = value;
	}

	public get Truncatedcardpan(): string {
		return this.truncatedcardpan;
	}
	public set Truncatedcardpan(value: string) {
		this.truncatedcardpan = value;
	}

	public get Cardtype(): string {
		return this.cardtype;
	}
	public set Cardtype(value: string) {
		this.cardtype = value;
	}

	public get Pseudocardpan(): string {
		return this.pseudocardpan;
	}
	public set Pseudocardpan(value: string) {
		this.pseudocardpan = value;
	}


	get MandateReference(): string {
		return this.mandateReference;
	}

	set MandateReference(value: string) {
		this.mandateReference = value;
	}

	get BankEinzugMitglied(): boolean {
		return this.bankEinzugMitglied;
	}
	set BankEinzugMitglied(value: boolean) {
		this.bankEinzugMitglied = value;
	}

	get Bankname(): string {
		return this.bankname;
	}
	set Bankname(value: string) {
		this.bankname = value;
	}

	get BankEinzugSchutzbrief(): boolean {
		return this.bankEinzugSchutzbrief;
	}
	set BankEinzugSchutzbrief(value: boolean) {
		this.bankEinzugSchutzbrief = value;
	}

	get Iban(): string {
		return this.iban;
	}

	set Iban(value: string) {
		this.iban = value;
	}

	/**
	 * The BIC that is only available, if the IBAN is not a german one (starting with DE).
	 *
	 * @return the bic, if the IBAN is not a germen one, else undefined.
	 */
	get Bic(): string {
		return this.bic;
	}

	/**
	 * The BIC that is only available if the IBAN is not a german one (starting with DE).
	 *
	 * @param value the bic, if the IBAN is not a germen one, else undefined.
	 */
	set Bic(value: string) {
		this.bic = value;
	}

	/**
	 * Flag, whether the user selected that the account owner differs from the ensurance applicant.
	 *
	 * @return true, if account owner differs, false otherwise.
	 */
	get HatAbweichendenKontoInhaber(): boolean {
		return this.hatAbweichendenKontoInhaber;
	}
	/**
	 * Flag, whether the user selected that the account owner differs from the ensurance applicant.
	 *
	 * @param value true, if account owner differs, false otherwise.
	 */
	set HatAbweichendenKontoInhaber(value: boolean) {
		this.hatAbweichendenKontoInhaber = value;
	}

	/**
	 * The differing account owner object, if applicable.
	 *
	 * @return AbwKontoInhaber model or undefined.
	 */
	get AbwKontoInhaber(): AbwKontoInhaberModel {
		return this.abwKontoInhaber;
	}

	/**
	 * The differing account owner object, if applicable.
	 *
	 * @param value AbwKontoInhaber model or undefined.
	 */
	set AbwKontoInhaber(value: AbwKontoInhaberModel) {
		this.abwKontoInhaber = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Creates a new BankdatenModel object and copies the values from the provided data object (or other Bankdaten model) to the created BankdatenModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): BankdatenModel {
		return AppUtils.Helper.createFromMap(dataObject, BankdatenModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'abwkontoinhaber') {
				return AbwKontoInhaberModel.createFromObject(value);
			} else {
				return value;
			}
		});
	}
}
